import RedemptionPage, { RedemptionPageStateProps } from 'components/features/pfm/RedemptionPage/RedemptionPage'
import internal from 'components/utils/Internal'
import { withRouter } from 'react-router'
import { createSelector } from 'reselect'
import { FORM_REDEMPTION } from 'constants/forms'
import { getFormValues, isSubmitting } from 'redux-form'
import { redemptionStepNumberSelector, redemptionSelector, isRedemptionFormCompletedSelector } from 'selectors/bountySelectors'
import { connect } from 'react-redux'
import { isMobileSelector } from 'selectors/viewportSelectors'
import { RedemptionFormValues } from 'interfaces/bounty'

const createMapStateToProps = () => createSelector(
  isMobileSelector,
  isRedemptionFormCompletedSelector,
  redemptionSelector,
  isSubmitting(FORM_REDEMPTION),
  getFormValues<Partial<RedemptionFormValues>>(FORM_REDEMPTION),
  redemptionStepNumberSelector,
  (isMobile, isRedemptionFormCompleted, redemption, isFormSubmitting, formValues = {}, redemptionStepNumber): RedemptionPageStateProps => ({
    isMobile,
    isRedemptionFormCompleted,
    isLoading: !redemption,
    isFormSubmitting,
    redemptionStepNumber,
    account_number: formValues.account_number || '',
  })
)

const RedemptionPageContainer = connect<
  RedemptionPageStateProps
>(createMapStateToProps)(internal(withRouter(RedemptionPage)))

export default RedemptionPageContainer
